import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFillRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 10,
	viewBox: "0 0 5 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 10L5 5L0 0L0 10Z",
		fill: "currentColor"
	})
});
export default SvgArrowFillRight;
